import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

/**
 * @param data
 * @param fileName
 */
export const exportToPDF = <T extends object>(
  data: T[],
  fileName = "document.pdf"
): void => {
  if (data.length === 0) return;

  const doc = new jsPDF();

  const columns = Object.keys(data[0]);

  const rows = data.map((row) => columns.map((col) => (row as any)[col]));

  doc.text("Izveštaj", 14, 20);

  autoTable(doc, {
    head: [columns],
    body: rows,
    startY: 30,
    styles: { fontSize: 10 },
    headStyles: { fillColor: [41, 128, 185] },
  });

  doc.save(fileName);
};
